import { memo } from 'react'
import type { InputHTMLAttributes } from 'react'

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string
}

const DEFAULT_MAX_LENGTH = 100

export const Input = memo(function Input({ label, className = '', maxLength = DEFAULT_MAX_LENGTH, ...props }: InputProps) {
  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium text-white/70 mb-2">{label}</label>
      )}
      <input
        maxLength={maxLength}
        className={`w-full px-6 py-4 bg-white/10 border-2 border-transparent rounded-full text-white text-lg font-medium placeholder:text-white/40 focus:outline-none focus:border-white/30 focus:bg-white/15 transition-all disabled:opacity-40 disabled:cursor-not-allowed ${className}`}
        {...props}
      />
    </div>
  )
})
